import { render } from "./NewMessageAlert.vue?vue&type=template&id=1eb3680c&scoped=true"
import script from "./NewMessageAlert.vue?vue&type=script&lang=js"
export * from "./NewMessageAlert.vue?vue&type=script&lang=js"

import "./NewMessageAlert.vue?vue&type=style&index=0&id=1eb3680c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb3680c"]])

export default __exports__